import React, { useState } from "react";
import { Box, IconButton, InputBase } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./SearchBar.module.css";

const SearchBar = ({ icon: IconComponent, onSearch, placeholder, className = "" }) => {
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSearchClick = () => {
    onSearch(inputValue);
  };

  return (
    <Box className={`${styles.searchBar} ${className}`}>
      <div className={styles.bgBlur} />
      <div className={styles.bg} />
      <InputBase
        className={styles.inputField}
        value={inputValue}
        onChange={handleInputChange}
        placeholder={placeholder}
        fullWidth
      />
      <IconButton onClick={handleSearchClick} className={styles.iconButton}>
        <IconComponent />
      </IconButton>
    </Box>
  );
};

SearchBar.propTypes = {
  icon: PropTypes.elementType.isRequired,
  onSearch: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default SearchBar;